import GainsightProvider from '@innovyze/stylovyze/lib/contexts/GainsightProvider';
import { AdskDataServiceProvider } from '@innovyze/stylovyze/lib/contexts/AdskDataServiceProvider';
import React from 'react';
import { getAuthenticationProvider } from '../../utils';
export const AnalyticsProvider = ({ useAdpAnalytics = false, children, }) => {
    const isForge = getAuthenticationProvider();
    // If we're using Forge, load the AdskDataServiceProvider.
    if (isForge && useAdpAnalytics) {
        return (React.createElement(AdskDataServiceProvider, null,
            React.createElement(GainsightProvider, null, children)));
    }
    // Otherwise, just load the GainsightProvider.
    return React.createElement(GainsightProvider, null, children);
};
